/**
 * StatsCard.js — Summary metric cards shown above the table
 */

import React from "react";

function Card({ label, value, icon, colorClass, bgClass }) {
  return (
    <div className={`glass-card p-5 flex items-center gap-4 hover:shadow-card-hover
                     transition-shadow duration-300`}>
      <div className={`w-12 h-12 rounded-2xl flex items-center justify-center
                       text-xl flex-shrink-0 ${bgClass}`}>
        {icon}
      </div>
      <div>
        <p className="text-2xl font-bold text-slate-800">{value}</p>
        <p className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>
          {label}
        </p>
      </div>
    </div>
  );
}

export default function StatsCard({ records }) {
  const total   = records.length;
  const present = records.filter((r) => r.status === "present").length;
  const denied  = records.filter((r) => r.status === "denied").length;

  // Unique UIDs
  const unique  = new Set(records.map((r) => r.uid)).size;

  const stats = [
    { label: "Total Scans",   value: total,   icon: "📋", colorClass: "text-brand-600",   bgClass: "bg-brand-50" },
    { label: "Present",       value: present, icon: "✅", colorClass: "text-emerald-600", bgClass: "bg-emerald-50" },
    { label: "Access Denied", value: denied,  icon: "🚫", colorClass: "text-red-500",     bgClass: "bg-red-50" },
    { label: "Unique Cards",  value: unique,  icon: "🪪", colorClass: "text-violet-600",  bgClass: "bg-violet-50" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <Card key={s.label} {...s} />
      ))}
    </div>
  );
}
